import React, { useEffect } from "react";
import { FiShare2 } from "react-icons/fi";
import { FaUsers } from "react-icons/fa";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import "./style/LoginPromptModal.css";
import "./style/ShareModal.css";

const ShareModal = ({ isOpen, onClose, shareUrl, onShareToEventPage }) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleShareSocial = () => {
    ReactGA.event({ category: 'engagement', action: 'social_share', label: 'social_network' });
    if (navigator.share) {
      navigator.share({ url: shareUrl, title: "Check out this photo!" }).catch(() => {});
    } else {
      navigator.clipboard.writeText(shareUrl).then(() => {
        const toast = document.createElement("div");
        toast.textContent = "Link copied to clipboard!";
        Object.assign(toast.style, {
          position: "fixed", bottom: "24px", left: "50%", transform: "translateX(-50%)",
          background: "#262626", color: "#fff", padding: "10px 20px", borderRadius: "8px",
          fontSize: "14px", zIndex: 9999, pointerEvents: "none",
        });
        document.body.appendChild(toast);
        setTimeout(() => document.body.removeChild(toast), 2800);
      }).catch(() => {});
    }
    onClose();
  };

  const handleShareEventPage = () => {
    ReactGA.event({ category: 'engagement', action: 'social_share', label: 'guest_gallery' });
    onShareToEventPage && onShareToEventPage();
    // onClose() is intentionally NOT called here — the caller handles
    // closing this modal and opening GuestGalleryShareModal in sequence.
  };

  return (
    <div className="lpm-overlay" onClick={onClose}>
      <div className="lpm-card" onClick={(e) => e.stopPropagation()}>
        <button className="lpm-close" onClick={onClose} aria-label="Close">✕</button>

        <div className="lpm-icon">
          <FiShare2 size={28} color="#595959" />
        </div>

        <h2 className="lpm-title share-modal-title">{t("share_modal.title")}</h2>
        <p className="lpm-sub">{t("share_modal.subtitle")}</p>

        <div className="lpm-actions">
          <button className="lpm-btn lpm-btn--primary share-modal-btn" onClick={handleShareSocial}>
            <FiShare2 className="share-modal-btn-icon" />
            {t("share_modal.share_btn")}
          </button>
          <button className="lpm-btn lpm-btn--secondary share-modal-btn" onClick={handleShareEventPage}>
            <FaUsers className="share-modal-btn-icon" />
            {t("share_modal.event_wall_btn")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
